import {AfterViewInit, Component, OnInit} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {CommonModule} from '@angular/common';
import {AdminNavbarComponent} from '../admin-navbar/admin-navbar.component';
import {AdminSidebarComponent} from '../admin-sidebar/admin-sidebar.component';
import * as feather from 'feather-icons';
import {AdminWrapperComponent} from '../admin-wrapper/admin-wrapper.component';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    CommonModule,
    AdminWrapperComponent,
    RouterOutlet,
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss'
})
export class AdminLayoutComponent {

}
